import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import store from './store'
import i18n from './i18n'
import VueMeta from 'vue-meta'

Vue.use(ElementUI)
Vue.prototype.$baseUrl = '/api'
Vue.config.productionTip = false
// 使用 Element-UI
Vue.use(ElementUI, {
    size: 'medium',
    zIndex: 3000,
})
Vue.use(VueMeta)

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')